export default {
    name: 'OfferRestricted',
    props: {
        show: Boolean,
        width: String,
        height: String,
        isMobile: Boolean,
        isReservedForYou: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        textModal() {
            return this.isReservedForYou
                ? 'Essa oportunidade do Engelink Marketing expirou'
                : 'A cotação está encerrada! Procure por novas cotações em nosso painel.';
        }
    }
};
